import { IconName } from "@techzyapp/ui-lib";

export const supportedLanguages = ["en-US", "ka-GE"];

const useTranslation = () => {
  const initilizeLanguageTabs = (
    Component: React.ElementType,
    detail?: any,
    index?: number,
  ) => {
    return supportedLanguages.map((languageCode) => ({
      label: languageCode,
      value: languageCode,
      content: (
        <Component languageCode={languageCode} detail={detail} index={index} />
      ),
      icon: "GlobalEdit" as IconName,
    }));
  };

  return {
    initilizeLanguageTabs,
    languages: supportedLanguages,
  };
};

export default useTranslation;
